import FormInput from "../UI/FormInput";

const CommonInput = ({ label = "Name", placeholder = "Name", id = null, required = true, multiline = false }) => {
  return <FormInput label={label} placeholder={placeholder} type="text" id={id} autoComplete={id} required={required} multiline={multiline} />;
};

export default CommonInput;
